import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { formatIDR, formatDateLong, clientName } from "../lib/format";
import { INQUIRY_STATUS_LABEL } from "../lib/constants";

export default function PrintInquiry() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/inquiries/${id}`).then(({ data }) => setD(data));
    document.title = "Print Inquiry";
  }, [id]);

  useEffect(() => {
    if (d) setTimeout(() => window.print(), 400);
  }, [d]);

  if (!d) return <div className="p-10">Memuat...</div>;

  return (
    <div className="min-h-screen bg-white p-8 print:p-6 max-w-3xl mx-auto text-[13px] text-[#1E2022]" data-testid="print-inquiry-doc">
      <style>{`@media print { @page { size: A4; margin: 12mm; } body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } .no-print { display: none !important; } }`}</style>

      <div className="flex items-center justify-between border-b-2 border-[#1E2022] pb-4">
        <div>
          <div className="font-display text-2xl font-bold">DESSY WEDDING GROUP</div>
          <div className="text-[11px] text-[#5C6066]">Garut · Bandung · Sekitarnya</div>
        </div>
        <div className="text-right">
          <div className="text-[11px] uppercase tracking-wide">Master Inquiry</div>
          <div className="font-mono font-bold">{d.inquiry_code}</div>
          <div className="text-[10px] text-[#5C6066] mt-1">Status: {INQUIRY_STATUS_LABEL[d.status]}</div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6 mt-6">
        <div>
          <div className="text-[10px] uppercase text-[#8C9096] font-semibold">Calon Klien</div>
          <div className="text-base font-semibold mt-1">{d.bride_name} {d.groom_name && `& ${d.groom_name}`}</div>
          <div className="text-[12px] mt-1">WA: {d.whatsapp || "-"}</div>
          <div className="text-[12px]">Email: {d.email || "-"}</div>
          <div className="text-[12px]">Instagram: {d.instagram || "-"}</div>
        </div>
        <div>
          <div className="text-[10px] uppercase text-[#8C9096] font-semibold">Detail Acara</div>
          <div className="text-base font-semibold mt-1">{d.event_name || "-"}</div>
          <div className="text-[12px] mt-1">Tanggal: {d.event_date ? formatDateLong(d.event_date) : "-"}</div>
          <div className="text-[12px]">Venue: {d.venue || "-"}, {d.location || "-"}</div>
          <div className="text-[12px]">Tamu: {d.guest_count || 0}</div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 mt-4 text-[11px]">
        <div><span className="text-[#8C9096]">Sumber Lead:</span> <span className="font-semibold">{d.source}</span></div>
        <div><span className="text-[#8C9096]">Budget Range:</span> <span className="font-semibold">{d.budget_range || "-"}</span></div>
        <div><span className="text-[#8C9096]">Paket Diminati:</span> <span className="font-semibold">{d.package_interest || "-"}</span></div>
      </div>

      {d.interest && (
        <div className="mt-4">
          <div className="text-[10px] uppercase text-[#8C9096] font-semibold">Kebutuhan Klien</div>
          <div className="text-[12px] mt-1 whitespace-pre-wrap">{d.interest}</div>
        </div>
      )}

      {d.lines?.length > 0 && (
        <>
          <div className="mt-6 text-[10px] uppercase text-[#8C9096] font-semibold">Preferensi Paket / Layanan (dari Master Pricelist)</div>
          <table className="w-full text-[12px] mt-2 border-collapse">
            <thead>
              <tr className="border-y-2 border-[#1E2022] bg-[#FAF6EE]">
                <th className="text-left p-2">Item</th>
                <th className="text-center p-2 w-16">Qty</th>
                <th className="text-right p-2 w-32">Harga Satuan</th>
                <th className="text-right p-2 w-32">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {d.lines.map((l) => (
                <tr key={l.id} className="border-b border-[#E5E0D8]">
                  <td className="p-2">
                    <div className="font-medium">{l.name}</div>
                    {l.notes && <div className="text-[10px] text-[#5C6066]">{l.notes}</div>}
                  </td>
                  <td className="text-center p-2">{l.quantity}</td>
                  <td className="text-right p-2 font-mono">{formatIDR(l.unit_price)}</td>
                  <td className="text-right p-2 font-mono">{formatIDR(l.line_total)}</td>
                </tr>
              ))}
              <tr className="bg-[#FAF6EE] border-t-2 border-[#1E2022]">
                <td colSpan={3} className="text-right p-2 font-bold">TOTAL ESTIMASI</td>
                <td className="text-right p-2 font-mono font-bold">{formatIDR(d.subtotal)}</td>
              </tr>
            </tbody>
          </table>
          <div className="text-[10px] text-[#8C9096] mt-1 italic">*Harga snapshot dari Master Pricelist saat inquiry dibuat. Penawaran final dapat berubah sesuai konfirmasi tim.</div>
        </>
      )}

      {d.notes && (
        <div className="mt-6">
          <div className="text-[10px] uppercase text-[#8C9096] font-semibold">Catatan</div>
          <div className="text-[12px] mt-1 whitespace-pre-wrap">{d.notes}</div>
        </div>
      )}

      {d.status_history?.length > 0 && (
        <div className="mt-6">
          <div className="text-[10px] uppercase text-[#8C9096] font-semibold">Timeline Status</div>
          <div className="text-[11px] mt-1 space-y-0.5">
            {d.status_history.map((h, i) => (
              <div key={i}>
                <span className="font-semibold">{INQUIRY_STATUS_LABEL[h.status] || h.status}</span> — {new Date(h.at).toLocaleString("id-ID")} {h.note && `— ${h.note}`}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="mt-10 grid grid-cols-2 gap-8 text-[11px]">
        <div className="text-center">
          <div>Ditugaskan kepada,</div>
          <div className="h-16"></div>
          <div className="border-t border-[#1E2022] pt-1 font-semibold">{d.assigned_name || "—"}</div>
        </div>
        <div className="text-center">
          <div>Calon Klien,</div>
          <div className="h-16"></div>
          <div className="border-t border-[#1E2022] pt-1 font-semibold">{d.bride_name} {d.groom_name && `& ${d.groom_name}`}</div>
        </div>
      </div>

      <div className="mt-6 pt-3 border-t border-[#E5E0D8] text-center text-[9px] text-[#8C9096]">
        DWOS — Dessy Wedding OS · Dokumen ini dicetak {new Date().toLocaleString("id-ID")}
      </div>

      <div className="no-print fixed top-4 right-4 flex gap-2">
        <button onClick={() => window.print()} className="px-4 py-2 bg-brand text-white rounded shadow" data-testid="btn-print">Cetak / Simpan PDF</button>
      </div>
    </div>
  );
}
